module.exports = __webpack_public_path__ + "static/about-bg-f94517742931c46b8e33ae56c1a178d8.png";